import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferLabel: Record<OfferKindEnum, string> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: '{{percentageAmount}}% korting vanaf {{minSpendValue}}',
  [OfferKindEnum.PercentageOffByProducts]: 'Bespaar {{percentageAmount}}% op geselecteerde artikelen',
  [OfferKindEnum.AmountOffByProducts]: 'Bespaar {{amount}} op geselecteerde artikelen',
  [OfferKindEnum.AmountOffByMinSpendValue]: 'Bespaar {{amount}} vanaf {{minSpendValue}}',
  [OfferKindEnum.Bogo]: '2 voor de prijs van 1 – alleen vandaag',
  [OfferKindEnum.BogoHalfPrice]: 'Koop één, krijg één voor halve prijs',
  [OfferKindEnum.FreeItemByProducts]: 'Vandaag: claim je gratis artikel!',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Vandaag: claim je gratis artikel bij een minimale bestelling!',
};

export default OfferLabel;
